<template>
  <div
    v-show="open"
    class="fixed z-50 inset-0 overflow-y-auto"
    role="dialog"
    aria-modal="true"
  >
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <transition name="modal-overlay">
        <div
          v-if="open"
          class="fixed inset-0 bg-gray-900/50 backdrop-blur-sm transition-all duration-300"
          aria-hidden="true"
        />
      </transition>

      <!-- This element is to trick the browser into centering the modal contents. -->
      <span
        class="hidden sm:inline-block sm:align-middle sm:h-screen"
        aria-hidden="true"
      >&#8203;</span>

      <transition name="modal-body">
        <div
          v-if="open"
          class="inline-block align-bottom bg-white/95 backdrop-blur-sm rounded-2xl px-6 pt-6 pb-4 text-left overflow-hidden shadow-2xl ring-1 ring-black/10 border border-gray-200/60 transform transition-all sm:my-8 sm:align-middle sm:w-full sm:p-8"
          :class="modalClasses ?? ''"
        >
          <div>
            <slot />
          </div>

          <slot name="footer" />
        </div>
      </transition>
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  open: boolean,
  modalClasses?: string,
}>(), {
  open: false,
  modalClasses: 'sm:max-w-lg',
});
</script>
